<template>
  <div>
    <v-card class="mb-5">
      <!-- Au moins une phrase ou une sous-bibliothèque -->
      <v-list two-line dense v-if="true">
        <v-subheader>
          {{ subBiblio.sentences.length }} {{ $tc('sentences', subBiblio.sentences.length <= 1) }}
        </v-subheader>
        <!-- phrases -->
        <template v-for="sentence in subBiblio.sentences">
          <wz-sentence
            :sentence="sentence"
            :biblio.sync="subBiblio"
          ></wz-sentence>
        </template>
        <!-- loader pour l'ajout d'une phrase -->
        <v-list-tile v-if="loadingSentence" class="text-xs-center">
          <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
        </v-list-tile>
      </v-list>

      <!-- Aucune phrase -->
      <v-container v-else fluid grid-list-lg>
        <v-layout row>
          <v-flex xs3>
             <v-img
                src="https://www.gstatic.com/mobilesdk/160505_mobilesdk/zerostate/2x/database.png"
                height="125px"
                contain
              ></v-img>
          </v-flex>
          <v-flex xs7>
            <div class="headline">Aucune phrase dans la sous-bibliothèque : {{ subBiblio.title }}</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

    <v-fab-transition>
      <v-btn
        fab
        bottom
        floating
        fixed
        raised
        right
        dark
        color="secondary"
        class="white--text"
        slot="activator"
        @click.native.stop="openDialogCreateSentence"
        v-show="!loadingSentence"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-fab-transition>

    <!-- DIALOGUE CREATION PHRASE-->
    <v-dialog v-model="showDialogCreateSentence" max-width="290">
      <v-card>
        <v-card-title class="primary white--text subheading">Créer une phrase</v-card-title>
        <v-divider></v-divider>
          <v-card-text>
            <v-text-field
              autofocus
              :label="$t('title')" 
              v-model="sentenceDialog.title"
              counter="256"
              multi-line 
              required
              v-validate="'required|max:256'" 
              data-vv-name="sentenceInput"
              :error="wzErrors.has('sentenceInput')"
              :error-messages="wzErrors.collect('sentenceInput')"
              @keyup.native.enter="submitDialogCreateSentence" 
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="showDialogCreateSentence = false">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" :disabled="wzErrors.any()" @click.native="submitDialogCreateSentence">{{ $t('submit') }}</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
export default {
  props: ['idParent', 'idSub'],

  data () {
    return {
      subBiblio: {},
      parentBiblio: {},

      /**
       * phrase gérée dans le dialogue
       * @type {Object}
       */
      subDialog: null,
      /**
       * indique si le dialog de création d'une phrase est affiché
       * @type {Boolean}
       */
      showDialogCreateSentence: false,

      /**
       * loader
       */
      loadingSentence: false
    }
  },

  created () {
    /**
     * checking des params de la route
     * @type {[type]}
     */
    this.parentBiblio = this.$store.getters['_Biblios/GET_BIBLIO_BY_ID'](this.idParent)
    // si pas de biblio avec cet ID
    if (!this.parentBiblio) {
      this.$router.push({ path: '/media/biblios' })
    }
    this.subBiblio = _.cloneDeep(_.find(this.parentBiblio.subs, {'id': this.idSub}))
    if (!this.subBiblio) {
      this.$router.push({ path: '/media/biblios' })
    }
    this.$store.commit('_Toolbar/SET_TABS', [])
    this.$store.commit('_Toolbar/SET_BACK', '/media/biblios/' + this.idParent)
    this.$store.commit('_Toolbar/SET_SUB_TITLE', this.subBiblio.title)

    this.sentenceDialog = this.newSentence()
  },

  methods: {
    /**
     * ouvre la fenêtre de dialogue et initialise une nouvelle phrase à créer
     */
    openDialogCreateSentence () {
      this.$validator.reset()
      this.sentenceDialog = this.newSentence()
      this.showDialogCreateSentence = true
    },
    /**
     * valide la nouvelle phrase à créer
     */
    submitDialogCreateSentence () {
      this.showDialogCreateSentence = false
      if (_.isEmpty(this.sentenceDialog.title)) {
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: 'Titre vide', context: 'warning' })
        return
      }
      // recherche de la phrase dans la liste des phrases
      // si elle n'est pas trouvée alors on peut la créer
      let sentenceFound = _.find(this.subBiblio.sentences, ['title', this.sentenceDialog.title])
      if (_.isNil(sentenceFound)) {
        this.loadingSentence = true
        // création côté serveur en BDD
        let dataToPost = new window.FormData()
        dataToPost.append('SEN_MSG', this.sentenceDialog.title)
        dataToPost.append('SEN_FAM_ID', this.subBiblio.id)
        this.axios.post('post/sentence.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then(response => {
          // les changements été pris en compte :
          // - attribution d'un id pour la biblio qui vient d'être créée
          this.sentenceDialog.id = response.data.id
          // recherche de la sous-biblio afin de la cloner
          let idxParent = _.findIndex(this.$store.state._Biblios.biblios, {'id': this.idParent})
          let idxSub = _.findIndex(this.$store.state._Biblios.biblios[idxParent].subs, {'id': this.idSub})
          this.subBiblio = _.cloneDeep(this.$store.state._Biblios.biblios[idxParent].subs[idxSub])
          // ajout de la phrase qui vient d'être sauvée en BDD
          this.subBiblio.sentences.push(this.sentenceDialog)
          // mise à jour du store avec la sous-biblio modifiée
          this.$store.commit('_Biblios/UPDATE_BIBLIO', this.subBiblio)
          // Notification
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('creationSuccess'), context: 'success' })
        })
        .catch(_ => {
          // Notification
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('creationFailure'), context: 'error' })
        })
        .then(_ => {
          this.loadingSentence = false
        })
      } else {
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('alreadyExists'), context: 'warning' })
      }
    },
    newSentence () {
      return {
        id: '',
        title: ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/media/SubBiblio.vue